import { activityCenterHttpClient, domainHttpClient } from '@/api/instances'
import { GET_NOTIFICATIONS, READ_NOTIFICATION, RETRY_JOB } from '@/api/rest/activity-center/endpoints'

export const getNotifications = async (queryParams = {}) => activityCenterHttpClient({
  url: GET_NOTIFICATIONS,
  method: 'GET',
  params: new URLSearchParams(queryParams)
})

export const readAllNotifications = async (queryParams = { read: false }) => activityCenterHttpClient({
  url: GET_NOTIFICATIONS,
  method: 'PATCH',
  params: new URLSearchParams(queryParams),
  data: {
    read: true
  }
})

export const readNotification = async notificationId => activityCenterHttpClient({
  url: READ_NOTIFICATION.replace(':id', notificationId),
  method: 'PATCH',
  data: {
    read: true
  }
})

export const retryJob = async ({ serviceName, correlationId }) => domainHttpClient({
  url: RETRY_JOB
    .replace(':serviceName', serviceName)
    .replace(':correlationId', correlationId),
  method: 'POST'
})
